import { Component } from "react";
import "./TextPrompt.css";
import { FaPaintBrush } from 'react-icons/fa';


class TextPrompt extends Component {

    state = {
        prompt: "",
    }

    handleTextAreaChange = (e) => {
        const newValue = e.target.value.replace(/(\r\n|\n|\r)/gm, "");
        this.setState({ [e.target.name]: newValue })
    }

    componentDidUpdate(prevProps) {
        if (this.props.prompt !== prevProps.prompt) {
            this.setState({ prompt: this.props.prompt });
        }
    }


    componentDidMount() {
        this.setState({ prompt: this.props.prompt });
    }

    render() {
        return (
            <div className="container-prompt">
                <textarea
                    placeholder="Describe your idea here. For instance: close up of a crystal ball reflecting the sunset in the mountains"
                    className="prompt-textArea"
                    name="prompt"
                    onChange={this.handleTextAreaChange}
                    value={this.state.prompt}
                    onKeyDown={(e) => { if (e.key === "Enter") this.props.submit(this.state.prompt) }}

                />
                <button
                    className="prompt-button"
                    onClick={() => this.props.submit(this.state.prompt)}>
                    <FaPaintBrush size={15} /> {' Paint'}
                </button>
            </div>
        );
    }
}

export default TextPrompt;